import { createSelector } from 'reselect';

const getId = (state) => state?.config?.affiliateId;
const getShouldShowAffiliateId = (state) => state?.config?.shouldShowAffiliateId;

const getAffiliateId = createSelector(
    [getId, getShouldShowAffiliateId], (affiliateId, shouldShowAffiliateId) => {
        return {
            affiliateIdFromConfig: affiliateId,
            shouldShowAffiliateId
        };
    }
);

export default getAffiliateId;
